(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PersonInfoQuery', PersonInfoQuery);

    PersonInfoQuery.$inject = ['$resource'];

    function PersonInfoQuery($resource) {


        var findByFirstName = function (firstName) {
            var resourceUrl = 'api/getPersonInfoByFirstName/' + firstName;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var findPersonInfoByQuery = function (query) {
            var resourceUrl = 'api/find-person-info-by-query?query=' + query;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            findByFirstName: findByFirstName,
            findPersonInfoByQuery: findPersonInfoByQuery
        };
    }
})();
